import { render } from "./ClassroomReadyDialog.vue?vue&type=template&id=39bc2a21"
import script from "./ClassroomReadyDialog.vue?vue&type=script&lang=js"
export * from "./ClassroomReadyDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__